/*
 * Copyright (c) 2025 Frayo and HomeChef360. All Rights Reserved.
 *
 * CONFIDENTIAL & PROPRIETARY
 * This software and its source code are the confidential and proprietary
 * information of Frayo and HomeChef360. Unauthorized copying, modification,
 * distribution, disclosure, or use of this code, in whole or in part, via any
 * medium, is strictly prohibited without prior written consent.
 *
 * Violations will be subject to legal action in the State of Florida and may
 * also be pursued under applicable U.S. federal law.
 */

import { useEffect, useRef, FC, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { listOrdersData } from '../../../auth/core/_requests';
import { useAuth } from '../../../auth/core/Auth'
import { } from '../../../../.'
interface Dish {
    uuid: string;
    orderId: string;
    netValue: any;
    orderstatus: {
        name: string;
    };
    orderdetails: [{
        dish: {
            name: string;
        }
        quantity: string;
    }];
}
const RecentOreder = () => {
    const [data, setData] = useState<Dish[]>([]);
    const { currentUser } = useAuth();
    const navigate = useNavigate()
    const chefId = currentUser?.uuid
    const viewDetails = () => {
        navigate('/orders/view')
    }

    const viewOrder = (id: any) => {
                //    navigate('/orders/view'+id)
        navigate('/orders/view')
    }

    useEffect(() => {

        listOrdersData(chefId).then((res: any) => {
            setData(res);
        });
    }, []);



    return (
        <div className="snippet-block recent-order">
            <div className="head">
                <h6 className="mb-0 fw-bold">Recent Orders</h6>
                <a href="#" className="text-link" onClick={viewDetails}>
                    View All
                    <i className="material-symbols-outlined fall">
                        arrow_forward
                    </i>
                </a>
            </div>
            <div className="ro-snippet-wrap">
                {data.length > 0 ? (
                    data.map((item, i) => (
                        <div className="card-wrap mb-3">
                            <p className="order-id">
                                <span>Order {item?.orderId}</span><span>$ {item?.netValue.toFixed(2)}</span>
                            </p>
                            <div className="card" onClick={() => viewOrder(item?.uuid)}>
                                <div className="row">
                                    <div className="col-7">
                                        {item?.orderdetails.map((orderDetail, j) => (
                                            <span key={j} className="item text-truncate">
                                                {orderDetail?.quantity} x {orderDetail?.dish?.name}
                                            </span>
                                        ))}
                                    </div>
                                    <div className="col-5 d-flex align-items-center justify-content-end">
                                        <span className={`status badge ${item?.orderstatus?.name?.toLowerCase()}`}>
                                            {item?.orderstatus?.name}
                                        </span>



                                        <i className="material-symbols-outlined go-ico"
                                            onClick={() => viewOrder(item?.uuid)}
                                        >
                                            chevron_right
                                        </i>
                                    </div>
                                </div>
                                </div>
                        
                        </div>
                    ))
                ) : (
                    <div className="text-center my-50px">
                        <div className="thumbnail ">
                            <img src='/assets/images/noDishes.svg' style={{ height: "100px" }} />
                        </div>
                        No Recent Orders
                    </div>)
                }
            </div>
        </div>
    )
}
export { RecentOreder }
